<script>
	import ScRenameWallet from '../otherdetails/SCRenameWallet.svelte';
	import CopyToClipboard from 'svelte-copy-to-clipboard';
	import { smartContractWalletAddress } from '../store';
	import { getShortAddress } from '$lib/util/util';
	import { optimism } from '@wagmi/core/chains';
	import { walletAddress } from '$lib/wallet/store';

	export let size = 'sm';
	let COPY_ADDRESS_PERSONAL = '';
	function handleSuccessCopyPersonal() {
		COPY_ADDRESS_PERSONAL = 'Copied';
		setTimeout(() => {
			COPY_ADDRESS_PERSONAL = '';
		}, 2000);
	}

	let COPY_ADDRESS_SC = '';
	function handleSuccessCopySC() {
		COPY_ADDRESS_SC = 'Copied';
		setTimeout(() => {
			COPY_ADDRESS_SC = '';
		}, 2000);
	}
</script>

<ScRenameWallet {size} />
<div class="grid grid-cols-2">
	<div class="flex gap-2 justify-start">
		<div class={`text-fx-grey-300 text-${size}`}>Smart Wallet</div>
		<CopyToClipboard
			text={$smartContractWalletAddress}
			on:copy={() => {
				handleSuccessCopySC();
			}}
			on:fail={() => {
				alert('Failed to copy. Please copy manually ' + $smartContractWalletAddress);
			}}
			let:copy
		>
			<button
				class={`text-fx-grey-400 flex items-center cursor-pointer text-${size}`}
				on:click={copy}
				on:keydown={copy}
			>
				<img src={'scwallet/copy.png'} loading="lazy" class="w-4 h-4" alt="copy" />
				{COPY_ADDRESS_SC}
			</button>
		</CopyToClipboard>
	</div>
	<div class={`text-${size} text-fx-gradient-14 text-right flex gap-1.5`}>
		<div class="grow" />
		<div class="flex items-center cursor-pointer">
			{getShortAddress($smartContractWalletAddress)}
		</div>

		<a
			href="{optimism.blockExplorers?.default.url}/address/{$smartContractWalletAddress}"
			target="_blank"
			rel="noopener noreferrer"
			class="ml-auto my-auto"
		>
			<div class="flex items-center">
				<img src={'external-link.svg'} loading="lazy" alt="help" class="w-5 h-5" />
			</div>
		</a>
	</div>
</div>
<div class="grid grid-cols-2">
	<div class="flex gap-2">
		<div class={`text-fx-grey-300 text-${size}`}>Your Wallet</div>
		<CopyToClipboard
			text={$walletAddress}
			on:copy={() => {
				handleSuccessCopyPersonal();
			}}
			on:fail={() => {
				alert('Failed to copy. Please copy manually ' + $walletAddress);
			}}
			let:copy
		>
			<button
				class={`flex items-center cursor-pointer text-fx-grey-400 text-${size}`}
				on:click={copy}
				on:keydown={copy}
			>
				<img src={'scwallet/copy.png'} loading="lazy" class="w-4 h-4" alt="copy" />
				{COPY_ADDRESS_PERSONAL}
			</button>
		</CopyToClipboard>
	</div>
	<div class={`text-${size} text-fx-gradient-14 text-right flex gap-1.5`}>
		<div class="grow" />
		<div class="flex items-center cursor-pointer">
			{getShortAddress($walletAddress)}
		</div>
		<a
			href="{optimism.blockExplorers?.default.url}/address/{$walletAddress}"
			target="_blank"
			rel="noopener noreferrer"
			class="ml-auto my-auto"
		>
			<div class="flex items-center">
				<img src={'external-link.svg'} loading="lazy" alt="help" class="w-5 h-5" />
			</div>
		</a>
	</div>
</div>
